/*
Contains all the routes pertaining to Dashboard Layout
Use the following structure: 
export const {name}Route = {
  ID: "",
  path: "/",
  element: "",
  index: true, (if the path is default for some folder)
  disableAuth: true, (if the page should always be in the dashboard)
}
*/

import pages from "../../constants/pages";
//list routes

import AudienceList from "../../pages/audience components/AudienceList";
import Campaign from "../../pages/campaign components/campaign list parent components/Campaign";

//details routes
import AgencyDetails from "../../pages/agency components/Agency";
import BrandDetails from "../../pages/brand components/BrandDetails";
import CompanyDetails from "../../pages/company components/CompanyDetails";
import AudienceDetails from "../../pages/audience components/AudienceDetails";
import CampaignDetails from "../../pages/campaign components/create campaign components/CampaignDetails";

//other routes
import Profile from "../../pages/profile components/Profile";
import ChangePassword from "../../pages/change password components/ChangePassword";
import AgentChannelSetting from "../../pages/channel agents setting components/AgentChannelSettings";
import Reporting from "../../pages/reporting components/Reporting";
import BrandAgencyList from "../../pages/agency brands components/BrandsList";
import DataEnrichments from "../../pages/data enrichments components/DataEnrichments";
import FAQ from "../../pages/technical faq components/FAQ";
import ReadyMadeCohorts from "../../pages/readymade cohorts/ReadyMadeCohorts";

//Main Module Components

const dashboardLayoutRoutes = {
  brandDetailsRoute: {
    ID: pages.brandDetails.ID,
    path: pages.brandDetails.route,
    role: ["monetization", "promotion", "AGENCY"],
    element: BrandDetails,
  },

  profileDetailsRoute: {
    ID: pages.profilePage.ID,
    path: pages.profilePage.route,
    role: ["monetization", "promotion", "AGENCY"],
    element: Profile,
  },

  companyDetailsRoute: {
    ID: pages.companyDetails.ID,
    path: pages.companyDetails.route,
    role: ["AGENCY", "monetization", "promotion"],
    element: CompanyDetails,
  },

  createCampaignRoute: {
    ID: pages.createCampaign.ID,
    path: pages.createCampaign.route,
    role: ["monetization"],
    element: CampaignDetails,
  },

  myCampaignRoute: {
    ID: pages.myCampaign.ID,
    path: pages.myCampaign.route,
    element: Campaign,
    role: ["SUPER_ADMIN", "monetization", "promotion"],
  },

  campaignDetailsRoute: {
    ID: pages.campaignDetails.ID,
    path: pages.campaignDetails.route + ":campaignID",
    element: CampaignDetails,
    role: ["monetization", "promotion"],
  },

  audienceListRoute: {
    ID: pages.audienceList.ID,
    path: pages.audienceList.route,
    element: AudienceList,
    role: ["monetization"],
  },

  createAudienceRoute: {
    ID: pages.createAudience.ID,
    path: pages.createAudience.route,
    element: AudienceDetails,
    role: ["monetization"],
  },

  audienceDetailsRoute: {
    ID: pages.audienceDetails.ID,
    path: pages.audienceDetails.route + ":audienceID",
    element: AudienceDetails,
    role: ["monetization"],
  },

  changePasswordRoute: {
    ID: pages.changePassword.ID,
    path: pages.changePassword.route,
    element: ChangePassword,
    role: ["monetization", "promotion", "AGENCY"],
  },

  channelAgentSettingRoute: {
    ID: pages.channelAgentSettingPage.ID,
    path: pages.channelAgentSettingPage.route,
    element: AgentChannelSetting,
    role: ["monetization"],
  },

  reportingRoute: {
    ID: pages.reportingPage.ID,
    path: pages.reportingPage.route,
    element: Reporting,
    role: ["monetization"],
  },

  technicalFAQRoute: {
    ID: pages.technicalFAQ.ID,
    path: pages.technicalFAQ.route,
    element: FAQ,
    role: ["monetization"],
  },

  readymadeCohorts: {
    ID: pages.readymadeCohorts.ID,
    path: pages.readymadeCohorts.route,
    element: ReadyMadeCohorts,
    role: ["monetization"],
  },

  // Agency

  agencyDetailsRoute: {
    ID: pages.agencyDashboardDetailPage.ID,
    path: pages.agencyDashboardDetailPage.route,
    element: AgencyDetails,
    role: ["AGENCY"],
  },

  createBrandEmptyRoute: {
    ID: pages.brandDetailCreateEmpty.ID,
    path: pages.brandDetailCreateEmpty.route,
    element: BrandDetails,
    role: ["AGENCY"],
  },

  brandsAgencyList: {
    ID: pages.agencyBrandsPage.ID,
    path: pages.agencyBrandsPage.route,
    element: BrandAgencyList,
    role: ["AGENCY"],
  },

  dataEnrichmentsRoutes: {
    ID: pages.dataEnrichments.ID,
    path: pages.dataEnrichments.route,
    element: DataEnrichments,
    role: ["monetization"],
  },
};

export default dashboardLayoutRoutes;
